import EntityBadge from '../EntityBadge.jsx';
import { formatCurrency } from '../../lib/format.js';

function EntityCell({ entityId, entityMap }) {
  const e = entityMap[entityId];
  return <EntityBadge slug={e?.slug} name={e?.name ?? entityId} />;
}

export default function RepartitionSection({ lines = [], entityMap = {} }) {
  const repartitionLines = lines.filter((l) => l.type === 'repartition');

  if (repartitionLines.length === 0) {
    return (
      <p className="text-sm text-slate-500 py-4 text-center">
        Aucune ligne de répartition. Cliquez sur Calculer pour générer.
      </p>
    );
  }

  return (
    <div className="overflow-x-auto -mx-1">
      <table className="min-w-full text-sm">
        <thead>
          <tr className="border-b border-slate-200 bg-slate-50">
            <th className="text-left text-xs font-medium text-slate-500 px-3 py-2.5 sticky left-0 bg-slate-50 whitespace-nowrap">
              Catégorie source
            </th>
            <th className="text-left text-xs font-medium text-slate-500 px-3 py-2.5 whitespace-nowrap">
              Émettrice
            </th>
            <th className="text-left text-xs font-medium text-slate-500 px-3 py-2.5 whitespace-nowrap">
              Débitrice
            </th>
            <th className="text-right text-xs font-medium text-slate-500 px-3 py-2.5 whitespace-nowrap hidden md:table-cell">
              Pool HT
            </th>
            <th className="text-right text-xs font-medium text-slate-500 px-3 py-2.5 whitespace-nowrap hidden md:table-cell">
              % alloué
            </th>
            <th className="text-right text-xs font-medium text-slate-500 px-3 py-2.5 whitespace-nowrap">
              Refacturé HT
            </th>
            <th className="text-right text-xs font-medium text-slate-500 px-3 py-2.5 whitespace-nowrap hidden lg:table-cell">
              TVA
            </th>
            <th className="text-right text-xs font-medium text-slate-500 px-3 py-2.5 whitespace-nowrap">
              TTC
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-slate-100">
          {repartitionLines.map((line) => (
            <tr key={line.id} className="hover:bg-slate-50">
              <td className="px-3 py-2.5 sticky left-0 bg-white hover:bg-slate-50 font-medium text-slate-900 whitespace-nowrap text-xs">
                {line.label ?? '—'}
              </td>
              <td className="px-3 py-2.5">
                <EntityCell entityId={line.from_entity_id} entityMap={entityMap} />
              </td>
              <td className="px-3 py-2.5">
                <EntityCell entityId={line.to_entity_id} entityMap={entityMap} />
              </td>
              <td className="px-3 py-2.5 text-right tabular-nums text-slate-600 whitespace-nowrap hidden md:table-cell">
                {formatCurrency(line.basis_amount_cents)}
              </td>
              <td className="px-3 py-2.5 text-right tabular-nums text-slate-600 whitespace-nowrap hidden md:table-cell">
                {line.allocation_pct != null ? `${line.allocation_pct} %` : '—'}
              </td>
              <td className="px-3 py-2.5 text-right tabular-nums text-slate-700 whitespace-nowrap font-medium">
                {formatCurrency(line.amount_ht_cents)}
              </td>
              <td className="px-3 py-2.5 text-right tabular-nums text-slate-500 whitespace-nowrap hidden lg:table-cell">
                {formatCurrency(line.vat_cents)}
              </td>
              <td className="px-3 py-2.5 text-right tabular-nums text-slate-900 whitespace-nowrap font-semibold">
                {formatCurrency(line.total_ttc_cents)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
